var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Watch } from "vue-property-decorator";
import Component from 'vue-class-component';
import moment from 'moment';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { auth } from '../../../helper/authDecorator';
import { nameDict } from '../../../constant/authCode';
import ClientService from '../../../api/ClientService';
import BasicArcheivesService from '../../../api/BasicArcheivesService';
var initFormData = {
    s_time: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD'),
    supplier_to_business_ids: [],
    supplier_upper_id: [],
    dimension: 1,
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.businessList = [];
        _this.supplierList = [];
        _this.selectRadio = 1;
        return _this;
    }
    BillHeader.prototype.created = function () {
        this.clientService = ClientService.getInstance();
        this.basicArcheivesService = BasicArcheivesService.getInstance();
        this.getBusinessList();
        this.getSupplier();
    };
    BillHeader.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    BillHeader.prototype.changeDimension = function (val, oldVal) {
        if (val == 1) {
            this.formData.dimension = 1;
        }
        else {
            this.formData.dimension = 2;
        }
    };
    BillHeader.prototype.mounted = function () {
        this.search();
    };
    BillHeader.prototype.getSupplier = function () {
        var _this = this;
        this.basicArcheivesService.getSupplierupperCategoryList().then(function (res) {
            var supplierData = Array.isArray(res.data.data) ? res.data.data : [];
            supplierData.forEach(function (item, index) {
                item.supplier_upper_id = new Date().getTime() + index;
                item.supplier_upper_name = item.category_name;
            });
            _this.supplierList = supplierData;
        });
    };
    BillHeader.prototype.getBusinessList = function () {
        var _this = this;
        this.clientService.getClientsByGroup().then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            listData.forEach(function (item, index) {
                item.supplier_to_business_id = item.group_id;
                item.business_name = item.group_name;
            });
            _this.businessList = listData;
        });
    };
    BillHeader.prototype.search = function () {
        var filter = __assign({}, this.formData);
        filter.supplier_to_business_ids = filter.supplier_to_business_ids && filter.supplier_to_business_ids.join(',');
        filter.supplier_upper_id = filter.supplier_upper_id && filter.supplier_upper_id.join(',');
        this.$emit('search', filter);
    };
    BillHeader.prototype.exportResult = function () {
        var url = "supplierclientapi/operation_report/export";
        url = UrlHelper.addParam(url, 'token', this.user.token);
        url = UrlHelper.addParam(url, 's_time', this.formData.s_time);
        url = UrlHelper.addParam(url, 'e_time', this.formData.e_time);
        url = UrlHelper.addParam(url, 'supplier_to_business_ids', this.formData.supplier_to_business_ids && this.formData.supplier_to_business_ids.join(','));
        url = UrlHelper.addParam(url, 'supplier_upper_id', this.formData.supplier_upper_id && this.formData.supplier_upper_id.join(','));
        url = UrlHelper.addParam(url, 'dimension', this.formData.dimension);
        location.href = url;
        window._czc.push(['_trackEvent', '采购订货', '采购订货导出']);
    };
    __decorate([
        Watch('selectRadio')
    ], BillHeader.prototype, "changeDimension", null);
    BillHeader = __decorate([
        auth(nameDict['经营报表'], true),
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
